import {Box, Modal, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {S3SignedUrl} from "../../Common/s3Bucket";

const BUCKET = "benchmark-violation-videos"
const VideoPreviewModal = ({handleOpen, handleClose, videoUrl}) => {
  const [loading, setLoading] = useState(false);
  const [videoClip, setVideoClip] = useState("");

  const getViolationClip = async () => {
    try {
      setLoading(true)
      const key = videoUrl.replace("s3://benchmark-violation-videos/", '');
      const signedUrl = await S3SignedUrl(BUCKET, key);
      setVideoClip(signedUrl);
    } catch (error) {
      console.error("Error fetching video: ", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (videoUrl) {
      getViolationClip();
    }
  }, [videoUrl]);

  return (
    <Modal open={handleOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "900px",
          bgcolor: "background.paper",
          p: 0.5,
          borderRadius: 2,
        }}
      >
        <Box>
          <Box>
            {loading ? (
              <Typography>Loading video...</Typography>
            ) : videoClip ? (
              <video autoPlay controls width="100%" height="100%">
                <source src={videoClip} type="video/mp4"/>
              </video>
            ) : (
              <Typography>No Preview available</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default VideoPreviewModal;
